<template>
	<div>
		<vue-dropzone 
			:ref="'myVueDropzone'"
			:id="'dropzone'+size" 
			:options="computedDropZoneOptions" 
			v-on:vdropzone-sending="sendingEvent"
			v-on:vdropzone-drop="droppedFile"
			v-on:vdropzone-complete="sendingComplete">Drag your file here</vue-dropzone>
		<input disabled type="text" class="form-control" :id="size" v-model="imageFieldObject[imageFieldKey]" >
	</div>
</template>

<script>

	import vue2Dropzone from 'vue2-dropzone'
	import 'vue2-dropzone/dist/vue2Dropzone.min.css'
	import routes from '@/router'

	export default {

		components: {
			vueDropzone: vue2Dropzone
		},

		name: 'ImageUploader',
		
		props: ['imageFieldKey', 'size', 'forTemplate', 'imageFieldObject'],

		data: function () {
			return {
				dropzoneOptions: {
					url: "https://fqwrgdp5j1.execute-api.eu-west-2.amazonaws.com/prod/upload-image",
					thumbnailWidth: 150,
					maxFilesize: 6,
					maxFiles:1,
					resizeWidth:1024,
					renameFile:this.renameFile,
					resizeQuality:0.9,
					headers:{
						Authorization:this.$store.getters['authToken']
					}
				}
			}
		},
		computed:{
			resizeWidth:function(){
				let newSize = 0
				switch(this.size){
					case "mobile":
						newSize = 800;
						break;
					case "tablet":
						newSize = 1024;
					break;
					case "tabletLarge":
						newSize = 1500;
					break;
					case "twitter-image":
						newSize = 800;
					break;
					case "audio-component-image":
						newSize = 561;
					break;
					case "bio":
						newSize = 300;
					break;
					case "social":
						newSize = 1200;
					break;
					case "desktop":
						newSize = 2000;
					break;
				}
				return newSize;
			},
			computedDropZoneOptions:function(){
				let computedOptiones = JSON.parse(JSON.stringify(this.dropzoneOptions))
				switch(this.size){
					case "sponsor":
						computedOptiones.resizeHeight = 100;
						break;
					case "more-content-unit":
						computedOptiones.resizeMethod = "contain"
						computedOptiones.resizeWidth = 500;
						break;
					default:
						computedOptiones.resizeWidth = this.resizeWidth;
				}
				return computedOptiones;
			}
		},
		methods:{
			sendingEvent (file, xhr, formData){
				this.imageFieldObject[this.imageFieldKey] = file.name.replace(/ /g,'');
				formData.append('forTemplate', this.forTemplate);
				formData.append('forRepository', routes.app.$route.params.repoName);
				formData.delete('file');
				formData.set('file', file, file.name.replace(/ /g,''))
				

				let newSize;

				switch(this.size){
					case "sponsor":
						newSize = this.logoUploadSizeCalc(file, {width:88*2, height:31*2})
						break;
					default:
				}

				if(newSize){
					console.log("RESIZE TO ", newSize)
					this.$refs.myVueDropzone.setOption("resizeWidth", newSize.width)
					this.$refs.myVueDropzone.setOption("resizeHeight", newSize.height)
				}
				
				this.$refs.myVueDropzone.setOption("headers", {
					Authorization:this.$store.getters['authToken']
				})
				
			},
			logoUploadSizeCalc(file, bounds){
				console.log("FILE WIDTH? ", file.width)
				let ratioH2W = file.height/file.width
				let ratioW2H = file.width/file.height
				console.log(ratioH2W)
				let newSize = {width: bounds.width, height:bounds.width*ratioH2W}
				console.log(ratioH2W, " ", ratioW2H, " ",newSize )
				if(newSize.height > bounds.height){
					newSize = {width: Math.round(bounds.height*ratioW2H), height:bounds.height}
				}

				return (newSize)

			},
			renameFile(file){
				console.log("OLD FILENAME = ",file)
				let newFilename = file.name.replace(/ /g,'')
				console.log("NEW FILENAME = ",file.name.replace(/ /g,''))
				return newFilename;
			},
			droppedFile(){
				this.$refs.myVueDropzone.removeAllFiles()
			},
			sendingComplete (){
			}
		}

	}
</script>

<style lang="scss" scoped>
	@import '@/scss/style.scss';
	
	.imageField{
		padding: 20px 0;
	}
	h5{
		padding-bottom: 10px;
	}

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>